import React from "react";
import classes from "./Home.module.css";
import binaryWorld from "../../img/binaryWorld.svg";
import code from "../../img/code.svg";
import WaveLine from "./wave";
import { motion } from "framer-motion";

function Home() {
  return (
    <div className={classes.Home} id="home">
      <div className={classes.Container}>
        <h1 className={classes.Hello}>Hello, world👋</h1>
        <h1 className={classes.Hello}>Welcome on my website</h1>
        <button className={classes.ResumeBtn}>
          <h2>
            <a
              href="https://www.mediafire.com/file/xg94ipe36e7x6mq/fw13_161_sachin_koli_%25281%2529.pdf/file"
              target="_blank"
            >
              RESUME
            </a>
          </h2>
        </button>
      </div>
      <WaveLine />
      <img className={classes.Code} src={code} alt="home img1"></img>
      <motion.img
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.5 }}
        className={classes.BinaryWorld}
        src={binaryWorld}
        alt="home img2"
      ></motion.img>
    </div>
  );
}

export default Home;
